/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
import { repository } from "../../clientInstance";
import InternalRedirect from "../../components/Navigation/InternalRedirect/InternalRedirect";
interface RunbookRunToRunbookTaskRedirectProps {
    spaceId: string;
    runbookRunId: string;
}
interface RunbookRunToRunbookTaskRedirectState extends DataBaseComponentState {
    redirectTo: LinkHref;
}
export default class RunbookRunToRunbookTaskRedirect extends DataBaseComponent<RunbookRunToRunbookTaskRedirectProps, RunbookRunToRunbookTaskRedirectState> {
    constructor(props: RunbookRunToRunbookTaskRedirectProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const runbookRunId = this.props.runbookRunId;
            const runbookRun = await repository.RunbookRuns.get(runbookRunId);
            const runbookSnapshot = await repository.RunbookSnapshots.get(runbookRun.RunbookSnapshotId);
            const path = links.projectRunbookRunDetailPage.generateUrl({
                spaceId: this.props.spaceId,
                projectSlug: runbookSnapshot.ProjectId,
                runbookId: runbookSnapshot.RunbookId,
                runbookRunId: runbookRun.Id,
                runbookSnapshotId: runbookSnapshot.Id,
            });
            this.setState({
                redirectTo: path,
            });
        });
    }
    render() {
        const redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return (<main>
                    <SkeletonLoadingLayout errors={this.errors}/>
                </main>);
        }
        return <InternalRedirect push={false} to={redirectTo}/>;
    }
    static displayName = "RunbookRunToRunbookTaskRedirect";
}
